import React, { useEffect, useState } from 'react';
import './ReporteStockModal.css'; // Asegúrate de que este archivo existe
import Cargando from '../../../../Cargando';
import PuenteApi from '../../../../pageauth/PuenteApi';
import GenerarPdf from "../GeneradorPdf/GenerarPDF";
import AuthUser from '../../../../pageauth/AuthUser';

const ReporteStockModal = ({ isVisible, onClose, SetMensaje }) => {

    const { ReporteStock } = GenerarPdf();
    const {getToken, getLogout, setToken, getModule, getModuleSector} = AuthUser()

    const [filtros, setFiltros] = useState({
        rubro: 'Todos',
        familia: 'Todos',
        deposito: getModule()+ " "+ getModuleSector(),
        seleccion: 'DESCRIPCION',
        noListarStockNegativo: false,
        filtrarPorGondola: false,
        gondola: '',
        listaDePrecios: 'LISTA DE PRECIO BASE',
    });

    const [rubros, setRubros] = useState([]);
    const [familias, setFamilias] = useState([]);
    const { ObtenerReporteStock, ObtenerFamiliaRubro } = PuenteApi();
    const { StartCargando, StopCargando } = Cargando();

    const obtenerRubrosYFamilias = async () => {
        try {
            const response = await ObtenerFamiliaRubro();
            if (response) {
                setRubros(response.rubros);
                setFamilias(response.familias);
            } else {
                SetMensaje("Error", "No se pudieron cargar los rubros y familias.", 5000);
            }
        } catch (error) {
            SetMensaje("Error", "Error al cargar rubros y familias: " + error.message, 5000);
        }
    };

    useEffect(() => {
        if(isVisible){
            obtenerRubrosYFamilias();
        }
    }, [isVisible]);

    const handleCancelar = () => {
        onClose(); // Cerrar el modal
    };

    const handleConfirmar = async () => {
        StartCargando("Generando Reporte...");
        try {
            const response = await ObtenerReporteStock(filtros);

            if (response && Array.isArray(response) && response.length > 0) {
                // Lógica de generación de PDF que ya tenías
                await ReporteStock(
                    response,
                    process.env.REACT_APP_RAZONSOCIAL,
                    process.env.REACT_APP_DOMICILIO,
                    process.env.REACT_APP_CUIT,
                    "LISTA DE PRECIO BASE"
                );
                // Si la generación fue exitosa, cerramos el modal
                // onClose();
            } else {
                SetMensaje("Advertencia", "No se encontraron datos de stock para los filtros seleccionados.", 3000);
            }
        } catch (error) {
            SetMensaje("Error", "Error al obtener datos o generar reporte: " + error.message, 5000);
        } finally {
            StopCargando();
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFiltros(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Si no está visible, no renderizamos nada
    if (!isVisible) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content-reporte"> {/* CLASE MODIFICADA */}
                <div className="modal-header-buzon">
                    <div className="modal-title-buzon">
                        <span className="buzon-icono">🗒️</span> Listado de Stock
                    </div>
                </div>
                <div className="modal-body-reporte">
                    {/* Sección de RANGOS (Izquierda) */}
                    <div className="reporte-section left-section">

                        {/* Rubro */}
                        <div className="campo-doble">
                            <div className="input-group">
                                <label>Rubro</label>
                                <select name="rubro" value={filtros.rubro} onChange={handleChange} className="select-rubro">
                                    <option value="Todos">Todos</option>
                                    {rubros.map((rubro, index) => (
                                        <option key={index} value={rubro}>{rubro}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Familia */}
                        <div className="campo-doble">
                            <div className="input-group">
                                <label>Familia</label>
                                <select name="familia" value={filtros.familia} onChange={handleChange} className="select-familia">
                                    <option value="Todos">Todos</option>
                                    {familias.map((familia, index) => (
                                        <option key={index} value={familia}>{familia}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Lista de Precios */}
                        <div className="input-group">
                            <label>Lista de Precios</label>
                            <div className="input-con-icono">
                                <input type="text" name="listaDePrecios" readOnly value={filtros.listaDePrecios} className="read-only-input" />
                                <span className="search-icon">🔍</span>
                            </div>
                        </div>

                    </div>

                    {/* Sección de OTRAS OPCIONES (Derecha) */}
                    <div className="reporte-section right-section">

                        {/* Depósito */}
                        <div className="input-group">
                            <label>Depósito</label>
                            <select name="deposito" value={filtros.deposito} onChange={handleChange} className="select-deposito">
                                <option value={getModule()+ " "+ getModuleSector()}>{getModule()+ " "+ getModuleSector()}</option>
                            </select>
                        </div>

                        {/* Selección (Dropdown) */}
                        <div className="input-group">
                            <label>Selección</label>
                            <select name="seleccion" value={filtros.seleccion} onChange={handleChange} className="select-seleccion">
                                <option value="DESCRIPCION">DESCRIPCION</option>
                            </select>
                        </div>

                        {/* No listar con Stock negativo */}
                        <div className="checkbox-group checkbox-solo">
                            <label>
                                <input
                                    type="checkbox"
                                    name="noListarStockNegativo"
                                    checked={filtros.noListarStockNegativo}
                                    onChange={handleChange}
                                />
                                No listar con Stock negativo
                            </label>
                        </div>


                        {/* Filtro por Góndola */}
                        <div className="checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="filtrarPorGondola"
                                    checked={filtros.filtrarPorGondola}
                                    onChange={handleChange}
                                />
                                Filtrar por góndola
                            </label>
                            {filtros.filtrarPorGondola && (
                                <div className="input-group-gondola">
                                    <div className="input-con-icono">
                                        <input type="text" name="gondola" value={filtros.gondola} onChange={handleChange} />
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>

                </div>

                {/* Pie de Página con Botones */}
                <div className="modal-footer-reporte">
                    <button className="boton-cancelar" onClick={handleCancelar}>
                        ❌ Cancelar
                    </button>
                    <button className="boton-confirmar" onClick={handleConfirmar}>
                        ✅ Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReporteStockModal;